import { render, staticRenderFns } from "./ScreenStationAdd.vue?vue&type=template&id=19b853a4&"
import script from "./ScreenStationAdd.vue?vue&type=script&lang=js&"
export * from "./ScreenStationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports